import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/usercenter/nftshiming.png';
import _imports_1 from '@assets/images/usercenter/nfticon.png';
const _withScopeId = n => (_pushScopeId("data-v-5c5eedba"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "nft-box"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "img"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "name-box"
};
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = {
  key: 0,
  class: "shiming"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 实名认证 ");
const _hoisted_11 = [_hoisted_9, _hoisted_10];
const _hoisted_12 = ["data-clipboard-text"];
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "钱包地址", -1));
const _hoisted_14 = {
  class: "nft"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "copy"
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "数字藏品", -1));
const _hoisted_17 = {
  class: "support-box"
};
const _hoisted_18 = {
  class: "list-box"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "img"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
  class: "name"
};
const _hoisted_23 = {
  class: "nftnnum"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_list = _resolveComponent("list", true);
  const _component_Error = _resolveComponent("Error");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [!$options.ifWxApp ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "back",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.back && $options.back(...args))
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: $data.userInfo.icon,
    alt: ""
  }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString($data.userInfo.nickname), 1), $data.userInfo.is_real_name_auth ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_11)) : _createCommentVNode("", true)]), !$data.toUserid ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "bottom",
    id: "copycode",
    "data-clipboard-text": $data.userInfo.wallet_address,
    onClick: _cache[1] || (_cache[1] = (...args) => $options.copySendProLink && $options.copySendProLink(...args))
  }, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString($data.userInfo.wallet_address), 1), _hoisted_15], 8, _hoisted_12)) : _createCommentVNode("", true)])]), _hoisted_16, $data.productList.length ? (_openBlock(), _createBlock(_component_list, {
    key: 0,
    loading: $data.loading,
    "onUpdate:loading": _cache[2] || (_cache[2] = $event => $data.loading = $event),
    finished: $data.finished,
    onLoad: $options.onLoad
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.productList, (item, index) => {
      return _openBlock(), _createElementBlock("div", {
        key: index,
        onClick: $event => $options.tontf(item),
        class: "list-item"
      }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("img", {
        src: item.img_url ? item.img_url : 'https://s.moimg.net/new/images/headPic.png'
      }, null, 8, _hoisted_21)]), _createElementVNode("div", _hoisted_22, [_createElementVNode("span", null, _toDisplayString(item.title), 1)]), _createElementVNode("div", _hoisted_23, [_hoisted_24, _createElementVNode("span", null, _toDisplayString(item.seq) + "/" + _toDisplayString(item.amount), 1)])], 8, _hoisted_19);
    }), 128))])])]),
    _: 1
  }, 8, ["loading", "finished", "onLoad"])) : (_openBlock(), _createBlock(_component_Error, {
    key: 1,
    message: "暂无藏品",
    img: "icon_nonft",
    class: "empty-box"
  }))]);
}